// @angular/core
import { Directive, OnDestroy } from '@angular/core';

// @angular/cdk/scrolling
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Directive({
    selector: 'cdk-virtual-scroll-viewport[viewport-auto-resize], fang-table-virtual-scroll-viewport[viewport-auto-resize]'
})
export class FangViewportAutoResizeDirective implements OnDestroy {

    //No types for now
    private resizeObserver: any;

    constructor(private cdkVirtualScrollViewport: CdkVirtualScrollViewport) {
        const ResizeObserver = (window as any).ResizeObserver;

        if (ResizeObserver) {
            this.resizeObserver = new ResizeObserver(() => this.cdkVirtualScrollViewport.checkViewportSize());

            this.resizeObserver.observe(this.cdkVirtualScrollViewport.elementRef.nativeElement);
        }
    }

    ngOnDestroy() {
        this.resizeObserver && this.resizeObserver.disconnect();
        this.resizeObserver = null;
    }
}
